import React from "react";
import styles from "./Hero.module.css";

export default function HeroM() {
  return <div className={styles.sectionContent} id="hero">
      <div className={styles.leftContent}>
        <div className={styles.sectionTitle}>
          <h1>
            Zmień opony <strong>{"niezależnie".toUpperCase()}</strong> od pory rok
          </h1>
        </div>
        <div className={styles.headerLinks}>
          <a href="#services">Zapoznaj się z ofertą</a>
          <a href="#price">Sprawdź nasze ceny</a>
        </div>
      </div>
      <div className={styles.rightContent}>
        <img src={`${process.env.PUBLIC_URL}/Images/Logo.webp`} alt="Logo" className={styles.logo} />
      </div>
    </div>;
}